import React from 'react';
import { MdError, MdRefresh } from 'react-icons/md';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex-1 p-4">
          <div className="h-full border border-red-300 rounded-lg overflow-hidden shadow-sm bg-red-50 flex items-center justify-center">
            <div className="text-center text-red-600 max-w-md">
              <MdError className="mx-auto text-4xl mb-4" />
              <h3 className="text-lg font-medium mb-2">Editor Error</h3>
              <p className="text-sm mb-4">
                Something went wrong with the code editor. This might be due to invalid file content.
              </p>
              <button
                onClick={this.handleReset}
                className="flex items-center space-x-2 mx-auto px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
              >
                <MdRefresh size={16} />
                <span>Try Again</span>
              </button>
              {process.env.NODE_ENV === 'development' && (
                <details className="mt-4 text-left">
                  <summary className="cursor-pointer text-sm font-medium">Error Details</summary>
                  <pre className="mt-2 text-xs bg-red-100 p-2 rounded overflow-auto max-h-32">
                    {this.state.error && this.state.error.toString()}
                    <br />
                    {this.state.errorInfo.componentStack}
                  </pre>
                </details>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;